export interface Deferred<T> {
  promise: Promise<T>;
  resolve: (next: T) => void;
  reject: (cause: any) => void;
}

export const getDeferred = <T>(): Deferred<T> => {
  const deferred: Partial<Deferred<T>> = {};
  deferred.promise = new Promise((resolve, reject) => {
    deferred.resolve = resolve;
    deferred.reject = reject;
  });
  return deferred as Deferred<T>;
};
